import { initContract, RouterOptions } from '@ts-rest/core';
export type {
  AppRoute,
  AppRouteMutation,
  AppRouter,
  ClientInferRequest,
  ClientInferResponseBody,
  ClientInferResponses,
  ServerInferRequest,
  ServerInferResponseBody,
  ServerInferResponses,
} from '@ts-rest/core';
import { textUsWebhook, webhookContract } from './contracts/webhookContract.js';
import { adminApiContract, oldAdminContract } from './contracts/adminContract.js';
import { embeddedContract } from './contracts/embeddedContract.js';
import { appContract } from './contracts/appContract.js';
import { ErrorResponse } from './apiSchemas.js';
import { z } from 'zod';
import { unsafeDebugContract } from './contracts/debugContract.js';

const c = initContract();

export const commonResponses = {
  400: ErrorResponse,
  401: ErrorResponse,
  403: ErrorResponse,
  404: ErrorResponse,
  500: ErrorResponse,
} as const satisfies RouterOptions['commonResponses'];

export const contract = c.router(
  {
    app: appContract,
    admin: oldAdminContract,
    unsafeDebug: unsafeDebugContract,
    adminApi: adminApiContract,
    embedded: embeddedContract,
    // webhooks: webhookContract,
    // Included for backwards compatibility
    // textUsWebhook
  },
  {
    commonResponses,
    baseHeaders: {
      Authorization: z.string().optional(),
      'Toro-Is-Embedded': z.string().optional(),
    },
  }
);
